import React from "react";
import { Badge, colors } from "../design/badge";
import { LockClosedIcon, ClockIcon, CheckCircleIcon, XCircleIcon } from "@heroicons/react/16/solid";

interface ReportStatusBadgeProps {
  status: "completed" | "pending" | "rejected" | "approved" | string;
  showIcon?: boolean;
}

const ReportStatusBadge: React.FC<ReportStatusBadgeProps> = ({ status, showIcon = true }) => {
  let color: keyof typeof colors;
  let title: string;
  let Icon: React.ComponentType<{ className?: string }> | null = null;
  let tooltip: string = "";

  switch (status) {
    case "completed":
      color = "green";
      title = "Finalized";
      Icon = LockClosedIcon;
      tooltip = "This report is finalized and locked for legal compliance";
      break;
    case "pending":
      color = "yellow";
      title = "Pending Review";
      Icon = ClockIcon;
      tooltip = "Awaiting admin review and approval";
      break;
    case "rejected":
      color = "red";
      title = "Needs Revision";
      Icon = XCircleIcon;
      tooltip = "Report requires changes before approval";
      break;
    case "approved":
      color = "blue";
      title = "Approved";
      Icon = CheckCircleIcon;
      tooltip = "Approved, PDF being generated";
      break;
    default:
      color = "zinc";
      title = status;
      break;
  }

  return (
    <Badge color={color} title={tooltip}>
      <span className="flex items-center gap-1">
        {showIcon && Icon && <Icon className="w-3 h-3" />}
        {title}
      </span>
    </Badge>
  );
};

export default ReportStatusBadge;
